import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { rowInteractionAction } from '../modules';

import EventAnalytics from '../components/EventAnalytics';

const mapDispatchToProps = dispatch => ({
  rowInteractionAction(interaction) {
    dispatch(rowInteractionAction(interaction));
  },
});

const mapStateToProps = state => {
  return {};
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {},
    componentDidUpdate() {},
  })
);

export default enhance(EventAnalytics);
